import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'blog-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss'],
    imports: [NgClass, CommonModule],
})
export class TagsComponent {
    @Input() public tags: string[] = [];
    @Input() public mouseHoveringParent = false;
    @Input() public heroImage = false;

    @Output() public clickTag = new EventEmitter<string>();

    public click(tag: string) {
        this.clickTag.emit(tag);
    }
}
